<app-nav-menu></app-nav-menu>

<router-outlet></router-outlet>

<!-- Footer-->
<footer class="footer bg-light">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
                <ul class="list-inline mb-2">
                    <li class="list-inline-item"><a href="https://southwestern.com/about/" target="_blank">About</a>
                    </li>
                    <li class="list-inline-item">⋅</li>
                    <li class="list-inline-item"><a
                            href="mailto:cjohnstone@southwestern.com?subject=SWFC Company Stock Plan">Contact</a></li>
                    <li class="list-inline-item">⋅</li>
                    <li class="list-inline-item"><a href="https://southwestern.com/terms-of-use/" target="_blank">Terms
                            of Use</a></li>
                    <li class="list-inline-item">⋅</li>
                    <li class="list-inline-item"><a href="https://southwestern.com/privacy-policy/"
                            target="_blank">Privacy Policy</a></li>
                </ul>
                <p class="text-muted small mb-4 mb-lg-0">&copy; Southwestern Family of Companies {{currentYear}}
                </p>
            </div>
            <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
                <ul class="list-inline mb-0">
                    <li class="list-inline-item mr-3">
                        <a href="https://www.facebook.com/Southwestern/" target="_blank"><i
                                class="fab fa-facebook fa-2x fa-fw"></i></a>
                    </li>
                    <li class="list-inline-item mr-3">
                        <a href="https://twitter.com/southwestern" target="_blank"><i
                                class="fab fa-twitter-square fa-2x fa-fw"></i></a>
                    </li>
                    <li class="list-inline-item">
                        <a href="https://www.instagram.com/southwesternfamilyofcompanies/" target="_blank"><i
                                class="fab fa-instagram fa-2x fa-fw"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>